import { useNavigate, useLocation } from "react-router-dom";
import { goToBackPageTransformer } from "../../utils";
import classes from "./ButtonBack.module.css";
 
type Props = {
  count: number,
  text: string,
  shortBtn?: boolean,
  userUrl?:  string,
}




const ButtonBack = ({
  count = 1,
  text = "Назад",
  shortBtn,
  userUrl,
}: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = (url?: string) => {
    if (url) navigate(url)
    else if (window.history.length > 3) {
      navigate(-1);
    } else {
   
      if((location.pathname).includes('retake-test') ||  (location.pathname).includes('results-retake'))  {
        const resUrl:string[] = (location.pathname).split('/');
        return navigate(`/admin/results/${resUrl[resUrl.length-1]}`, )
      } 
      navigate(goToBackPageTransformer(count, location.pathname));
    }
  };

  return (
    <button
      className={`admin__results__link ${shortBtn ? classes.shortBtn : ""}`}
      onClick={() => goBack(userUrl)}
    >
      {text}
    </button>
  );
};

export default ButtonBack;
